import { documentSetCookie } from '../cookie';

export const ADS_SET_KACHING_INSTANCE = 'ads/SET_KACHING_INSTANCE';
export const ADS_SET_KACHING_CONFIG = 'ads/SET_KACHING_CONFIG';
export const ADS_SET_KACHING_INITIALIZED = 'ads/SET_KACHING_INITIALIZED';
export const ADS_SHOW_BLOCKER_CONSENT = 'ads/ADS_SHOW_BLOCKER';

export const adsSetKachingInstanceAction = payload => ({ type: ADS_SET_KACHING_INSTANCE, payload });
export const adsSetKachingConfig = payload => ({ type: ADS_SET_KACHING_CONFIG, payload });
export const adsSetKachingInitializedAction = payload => ({ type: ADS_SET_KACHING_INITIALIZED, payload });
export const adsShowBlockerConsentAction = payload => ({ type: ADS_SHOW_BLOCKER_CONSENT, payload });

export const changeAdsShowBlockerConsentPersistent = filterValue => dispatch => {
  documentSetCookie('adsShowBlockerConsent', filterValue);
  dispatch(adsShowBlockerConsentAction(filterValue));
};

export const adsInitialState = {
  kachingInstance: null,
  kachingConfig: {},
  kachingInitialized: false,
  adsShowBlockerConsent: false,
};

export const adsReducer = (state = adsInitialState, { type, payload }) => {
  switch (type) {
  case ADS_SET_KACHING_INSTANCE:
    return {
      ...state,
      kachingInstance: payload,
    };
  case ADS_SET_KACHING_CONFIG:
    return {
      ...state,
      kachingConfig: payload,
    };
  case ADS_SET_KACHING_INITIALIZED:
    return {
      ...state,
      kachingInitialized: payload,
    };
  case ADS_SHOW_BLOCKER_CONSENT:
    return {
      ...state,
      adsShowBlockerConsent: payload,
    };
  }
  return state;
};

export const selectKachingInstance = state => state.ads.kachingInstance;
export const selectKachingConfig = state => state.ads.kachingConfig;
export const selectKachingInitialized = state => state.ads.kachingInitialized;
export const selectAdsShowBlockerConsent = state => state.ads.adsShowBlockerConsent;

let slotsToDefine = [];
let slotsDefined = [];
let slotsToDestroy = [];
let delayedUpdateTimeout = null;

const updateSlots = () => (dispatch, getState) => {
  const kaching = selectKachingInstance(getState());
  if (!kaching) {
    return;
  }
  if (delayedUpdateTimeout !== null) {
    clearTimeout(delayedUpdateTimeout);
  }
  delayedUpdateTimeout = setTimeout(() => {
    slotsToDefine = slotsToDefine.filter(s => !containsSlot(slotsDefined.concat(slotsToDestroy), s));
    slotsToDestroy = slotsToDestroy.filter(s => containsSlot(slotsDefined, s));
    if (slotsToDestroy.length > 0) {
      slotsToDestroy.forEach(({ adType, adNumber }) => kaching.destroy(`ad_${adType}-${adNumber}`));
      slotsDefined = slotsDefined.filter(s => !containsSlot(slotsToDestroy, s));
      slotsToDestroy = [];
    }
    if (slotsToDefine.length > 0) {
      slotsToDefine.forEach(
        ({ adType, adNumber, adunit, adOptions }) => kaching.defineSlot(
          adType, adNumber, { adUnit: adunit, ...adOptions },
        ),
      );
      slotsDefined = slotsDefined.concat(slotsToDefine);
      slotsToDefine = [];
      try {
        const config = selectKachingConfig(getState());
        kaching.init(config).then(() => { /* no-op */
        });
      } catch (e) { /* no-op */
      }
    }
  }, 200);
};

const slotsEqual = (s1, s2) => ['adType', 'adNumber', 'itemId'].every(p => s1[p] === s2[p]);
const containsSlot = (arr, slot) => arr.some(s => slotsEqual(s, slot));

export const adsInitOp = () => (dispatch, getState) => {
  if (selectKachingInstance(getState()) !== null) {
    return;
  }
  const onInitComplete = () => {
    dispatch(adsSetKachingInitializedAction(true));
    dispatch(updateSlots());
  };
  // eslint-disable-next-line no-undef
  const kaching = new KaChing();
  const config = selectKachingConfig(getState());
  try {
    kaching.init(config)
      .then(() => { /* no-op */
      })
      .finally(onInitComplete);
  } catch (e) {
    onInitComplete();
  }

  setTimeout(onInitComplete, 2500);
  dispatch(adsSetKachingInstanceAction(kaching));
};

export const adsDefineSlotOp = slot => dispatch => {
  if (containsSlot(slotsToDestroy, slot)) {
    slotsToDestroy = slotsToDestroy.filter(s => !slotsEqual(s, slot));
  }
  if (!containsSlot(slotsDefined, slot)) {
    slotsToDefine.push(slot);
    dispatch(updateSlots());
  }
};

export const adsDestroySlotOp = slot => dispatch => {
  if (containsSlot(slotsDefined, slot)) {
    slotsToDestroy.push(slot);
    dispatch(updateSlots());
  } else if (containsSlot(slotsToDefine, slot)) {
    slotsToDefine = slotsToDefine.filter(s => !slotsEqual(s, slot));
  }
};
